import { render } from "./ListeRegime.vue?vue&type=template&id=072cf762&ts=true"
import script from "./ListeRegime.vue?vue&type=script&lang=ts"
export * from "./ListeRegime.vue?vue&type=script&lang=ts"

import "./ListeRegime.vue?vue&type=style&index=0&id=072cf762&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__